<template>
   <div class="o-online-orders">
        <h2>Online Orders</h2>

        <div v-if="loadingOrders" class="c-loader">
            loading
        </div>

        <div v-else-if="error" class="o-online-orders__error">
            {{ error }}
        </div>

        <table v-else-if="orders.length" class="o-online-orders__table">
            <thead>
                <tr>
                    <th>Order ID</th>
                    <th>Customer PO</th>
                    <th>Date</th>
                    <th>Order Code</th>
                    <th>Status</th>
                    <th>Value</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="order in orders" :key="order.id">
                    <td>{{ order.id }}</td>
                    <td>{{ order.attributes.customerPO }}</td>
                    <td>{{ formatDate(order.attributes.date)}}</td>
                    <td>{{ order.attributes.salesOrderCode }}</td>
                    <td>{{ order.attributes.status }}</td>
                    <td>{{ order.attributes.value }}</td>
                </tr>
            </tbody>
        </table>

        <p v-else>You don't have any orders yet.</p>

    </div>

</template>

<script>
    export default {
        name: 'OnlineOrders',
        props: {
            accountNumber: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                orders: [],
                error: null,
                loadingOrders: false,
            };
        },
        computed: {
        },
        methods: {
            formatDate(dateString) {
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                
                return `${day}/${month}/${year}`;
            },
            async fetchOrders() {
                this.loadingOrders = true;

                try {
                    const response = await fetch(
                        `/rest/V1/swallowdental/online-orders`,
                    );

                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const data = await response.json();
                    this.loadingOrders = false;
                    data[0].sort((a, b) => new Date(b.attributes.date) - new Date(a.attributes.date));
                    this.orders = data[0]; 

                } catch (error) {
                    this.loadingOrders = false;
                    this.error = error.message;
                    console.error("Error fetching transactions:", error);
                }
            }
        },
        mounted() {
            this.fetchOrders();
        }
    };
</script>